export const TREELY_CDN_URI =
  "https://cdn.tree.ly/assets/v5/registry-app/categories";
